import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';

import { providePrimeNG } from 'primeng/config';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { AuthEffects } from './auth/store/auth.effects';
import { provideStore } from '@ngrx/store';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { authReducer } from './auth/store/auth.reducer';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { jwtOptionsFactory } from './shared/utilities';
import { CookieService } from './shared/services/cookie.service';
import { AuraTamPreset } from './themes/aura-tams';
import { CommonEffects } from './metadata/store/common.effects';
import { commonReducer } from './metadata/store/common.reducer';
import { assetsReducer } from './assets/store/assets.reducer';
import { AssetsEffects } from './assets/store/assets.effects';
import { globalReducer, loadingMetaReducer } from './shared/store/global';
import { userReducer } from './management/store/user.reducer';
import { UserEffects } from './management/store/user.effects';
import { auditTrailReducer } from './management/store/audit-trail.reducer';
import { AuditTrailEffects } from './management/store/audit-trail.effect';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AuraTamPreset,
        options: {
          darkModeSelector: '.dark-mode-selector'
        }
      },
    }),

    // auth providers
    {
      provide: JWT_OPTIONS,
      useFactory: jwtOptionsFactory,
      deps: [CookieService]
    },
    JwtHelperService,
    provideHttpClient(withInterceptors([authInterceptor])),
    provideStore(
      {
        auth: authReducer,
        common: commonReducer,
        assets: assetsReducer,
        global: globalReducer,
        userManagement: userReducer,
        auditTrailManagement: auditTrailReducer
      },
      {
        metaReducers: [loadingMetaReducer]
      }
    ),
    provideEffects(AuthEffects, CommonEffects, AssetsEffects, UserEffects, AuditTrailEffects),
    provideStoreDevtools(
      {
        maxAge: 25,
        logOnly: !isDevMode()
      }
    ),

    // services
    MessageService,
  ]
};
